import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import learningportalSvg from "../../assets/image/learningportal.svg";
import { userType } from "../../config/userType";
import { setUser } from "../../features/Auth/authSlice";
import { selectUser } from "../../features/Auth/selectAuth";
import routes from "../../config/routeConfig";

export default function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const user = useSelector(selectUser);
  const isQuizPage = pathname.includes("/quiz");

  const handleLogout = (user) => {
    if (user === userType[0]) {
      navigate(routes.admin.login);
    } else if (user === userType[1]) {
      navigate(routes.student.login);
    }
    dispatch(setUser(null));
  };

  return (
    <nav className="shadow-md">
      <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
        <Link
          to={
            user?.role === userType[0]
              ? routes.admin.dashboard
              : routes.student.coursePlayer
          }
        >
          <img
            className="h-10"
            src={learningportalSvg}
            alt="learningportal logo"
          />
        </Link>
        <div className="flex items-center gap-3">
          {user?.role === userType[1] && (
            <>
              {isQuizPage || (
                <Link
                  to={routes.student.leaderboard}
                  className={`${
                    pathname === routes.student.leaderboard ? "font-bold" : ""
                  }`}
                >
                  Leaderboard
                </Link>
              )}
              <h2
                className={`${
                  pathname === routes.student.coursePlayer ? "font-bold" : ""
                }`}
              >
                {user?.name}
              </h2>
              <button
                onClick={() => handleLogout(userType[1])}
                className={
                  isQuizPage
                    ? "flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium"
                    : "flex gap-2 border border-cyan items-center px-4 py-1 rounded-full text-sm transition-all hover:bg-cyan"
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                  />
                </svg>
                Logout
              </button>
            </>
          )}

          {user?.role === userType[0] && (
            <>
              <h2 className="font-bold">{user?.name}</h2>
              <button
                onClick={() => handleLogout(userType[0])}
                className="flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                  />
                </svg>
                Logout
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
